let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("55otQ")).then(() => parcelRequire('eM952'));